import moment from "moment";
import { typeOfPAF } from "../../../../constants/typeOfPAF";

/**
 * Builds the POST body for `PRESCRIPTIONS_CREATE_POST` from wizard state.
 */
export function buildPatientInitiationCreatePayload({
  registerPatient,
  checkedItems,
  checkedItemsPrescriber,
  storageData,
}) {
  let copyOfRegisterPatient = { ...registerPatient };

  copyOfRegisterPatient.patient_dob = moment(copyOfRegisterPatient.patient_dob).format(
    "YYYY-MM-DD"
  );

  copyOfRegisterPatient.pregnancy_test =
    copyOfRegisterPatient?.pregnancy_test === undefined ||
    copyOfRegisterPatient?.pregnancy_test === null
      ? undefined
      : moment(copyOfRegisterPatient?.pregnancy_test).format("YYYY-MM-DD");

  copyOfRegisterPatient.indication =
    copyOfRegisterPatient?.indication?.id === undefined ||
    copyOfRegisterPatient?.indication?.id === null
      ? undefined
      : copyOfRegisterPatient?.indication?.id;

  if (
    copyOfRegisterPatient.type === typeOfPAF.MALE ||
    copyOfRegisterPatient.type === typeOfPAF.WOMANOFNCP
  ) {
    delete copyOfRegisterPatient.pregnancy_test;
  }

  const handedHospitalName =
    storageData?.hospital?.value + ", " + storageData?.hospital?.address;

  copyOfRegisterPatient.hospital_name_and_address =
    copyOfRegisterPatient.hospital_name_and_address ?? handedHospitalName;

  copyOfRegisterPatient.prescription_confirmation_risks = Object.keys(checkedItems)
    .filter((key) => key.startsWith("risk-checkbox-"))
    .reduce((obj, key) => {
      const id = key.split("-")[2];
      obj[id] = checkedItems[key];
      return obj;
    }, {});

  copyOfRegisterPatient.prescriber_confirmations = Object.keys(
    checkedItemsPrescriber
  )
    .filter((key) => key.startsWith("checkbox-prescriber-"))
    .reduce((obj, key) => {
      const id = key.split("-")[2];
      obj[id] = checkedItemsPrescriber[key];
      return obj;
    }, {});

  delete copyOfRegisterPatient.confirmation_other1;

  const patient = {
    patient_initials: copyOfRegisterPatient.patient_initials,
    dob: copyOfRegisterPatient.patient_dob,
    patient_type:
      copyOfRegisterPatient?.type === "male"
        ? 0
        : copyOfRegisterPatient?.type === "womanOfCP"
          ? 1
          : 2,
    counselling_date: moment().format("YYYY-MM-DD"),
  };

  copyOfRegisterPatient = {
    ...copyOfRegisterPatient,
    patient,
  };

  if (copyOfRegisterPatient.type === "womanOfNCP") {
    copyOfRegisterPatient.confirmation_risk_patient = true;
  }

  if (copyOfRegisterPatient?.number_cycles?.id) {
    copyOfRegisterPatient = {
      ...copyOfRegisterPatient,
      n_cycles: copyOfRegisterPatient?.number_cycles?.id,
    };
  }

  if (copyOfRegisterPatient?.number_weeks?.id) {
    copyOfRegisterPatient = {
      ...copyOfRegisterPatient,
      n_weeks: copyOfRegisterPatient?.number_weeks?.id,
    };
  }

  if (copyOfRegisterPatient?.other) {
    copyOfRegisterPatient = {
      ...copyOfRegisterPatient,
      n_weeks_other: +copyOfRegisterPatient?.other,
      n_weeks: +copyOfRegisterPatient?.number_weeks?.id,
    };
  }

  if (copyOfRegisterPatient?.weeks_per_cycle) {
    copyOfRegisterPatient = {
      ...copyOfRegisterPatient,
      weeks_per_cycle:
        copyOfRegisterPatient?.weeks_per_cycle?.id !== 0
          ? +copyOfRegisterPatient?.weeks_per_cycle?.id
          : copyOfRegisterPatient?.n_weeks_other,
    };
  }

  !!copyOfRegisterPatient?.capsules &&
    copyOfRegisterPatient?.capsules?.map((element) => {
      delete element.strengths;
      return element;
    });
  delete copyOfRegisterPatient.type;
  delete copyOfRegisterPatient.number_cycles;
  delete copyOfRegisterPatient.number_weeks;
  delete copyOfRegisterPatient.other;
  delete copyOfRegisterPatient.total_capsules;
  delete copyOfRegisterPatient.patient_initials;
  delete copyOfRegisterPatient.patient_dob;
  delete copyOfRegisterPatient.nonComplaintValidationPassed;
  delete copyOfRegisterPatient.drug;
  delete copyOfRegisterPatient.drugId;
  delete copyOfRegisterPatient.continueWithoutConfirmation;
  delete copyOfRegisterPatient.continueWithPregnancyTestDateOutdated;
  delete copyOfRegisterPatient.continueWithPregnancyTestDateIncomplete;
  delete copyOfRegisterPatient.continueOffLabel;
  delete copyOfRegisterPatient.continueIndicationIncomplete;
  delete copyOfRegisterPatient.continueMaximumNumberOfCyclesExceeded;
  delete copyOfRegisterPatient.continueMaximumNumberOfWeeksExceeded;
  delete copyOfRegisterPatient.continueMaximumNumberOfWeeksExceededAgain;
  delete copyOfRegisterPatient.continueMaximumNumberOfCapsulesExceeded;
  delete copyOfRegisterPatient.continueWithDateOfBirthUnderEighteen;
  delete copyOfRegisterPatient.continueCapsulePerCycleIncomplete;
  delete copyOfRegisterPatient.continueCapsulePerWeekIncomplete;
  delete copyOfRegisterPatient.continueNumberOfCyclesIncomplete;
  delete copyOfRegisterPatient.continueNumberOfWeeksIncomplete;

  return copyOfRegisterPatient;
}
